import React from 'react';
import PropTypes from 'prop-types';

import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { validateStep2 } from './validations';
import normalizePhone from '../Widget/normalizePhone';

import { Field } from 'redux-form';
import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import CheckboxGroup from '../CheckboxGroup';
import DropDownSelect from '../DropDownSelect';

import GetUpdatesCheckbox from '../Widget/GetUpdatesCheckbox';

import {
    Container,
    ButtonGroupWrapper,
    MultipleGroupWrapper,
    MultipleGroupFull,
    MultipleGroupLastLarge
} from '../../containers/DefaultStyles/FormDetails';

import { LoadingSpinner } from '../../components/LoadingSpinner';

const MultipleGroupFullSmall = MultipleGroupFull.extend`
    margin-bottom: 0.2em;
`;

class VoteRegistrationStep2Form extends React.Component {
    render() {
        return (
            <Container autocomplete="on" onSubmit={this.props.handleSubmit}>
                <MultipleGroupLastLarge>
                    <Field
                        name="homeAddress"
                        component={InputGroup}
                        type="text"
                        label="Street No & Street"
                        placeholder="Street No & Street"
                        autocomplete="off"
                    />
                    <Field
                        name="unit"
                        component={InputGroup}
                        type="text"
                        label="Unit"
                        placeholder="Unit"
                        autocomplete="off"
                    />
                </MultipleGroupLastLarge>
                <MultipleGroupFull>
                    <Field
                        name="homeCity"
                        component={InputGroup}
                        type="text"
                        label="Home city"
                        placeholder="Home City"
                        autocomplete="off"
                    />
                </MultipleGroupFull>
                <MultipleGroupWrapper>
                    <Field
                        name="stateId"
                        component={DropDownSelect}
                        options={this.props.states}
                        defaultOption={'Choose'}
                        label="State"
                        type="text"
                    />
                    <Field
                        name="postalCode"
                        component={InputGroup}
                        type="text"
                        label="Postal code"
                        placeholder="Postal Code"
                        autocomplete="off"
                        maxLength={5}
                    />
                    <Field
                        name="phone"
                        component={InputGroup}
                        type="text"
                        label="Phone"
                        placeholder="Phone"
                        autocomplete="off"
                        normalize={normalizePhone}
                    />
                </MultipleGroupWrapper>
                <MultipleGroupFullSmall>
                    <Field
                        name="smsUpdates"
                        defaultChecked={true}
                        component={CheckboxGroup}
                        label="I'd like to receive SMS updates"
                        normalize={v => !!v}
                    />
                    <Field
                        name="confirmationEmail"
                        defaultChecked={true}
                        component={CheckboxGroup}
                        label="Send confirmation email"
                        normalize={v => !!v}
                    />
                </MultipleGroupFullSmall>
                <MultipleGroupFull>
                    <GetUpdatesCheckbox labelText="I'd like to receive email updates" />
                </MultipleGroupFull>
                <ButtonGroupWrapper
                    isFormSubmitting={this.props.isAddressSubmitting}
                    rightPosition={23}
                >
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <Button
                            primary={true}
                            type="submit"
                            label="Continue"
                            className="submitButton"
                            disabled={this.props.invalid}
                            isSubmitting={this.props.isFormSubmitting}
                        />
                        <LoadingSpinner />
                    </TwoGroup>
                </ButtonGroupWrapper>
            </Container>
        );
    }
}

VoteRegistrationStep2Form.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    postalCode: PropTypes.string,
    states: PropTypes.array,
    handleSubmit: PropTypes.func,
    isAddressSubmitting: PropTypes.bool
};

export default compose(
    connect(state => ({
        initialValues: {
            postalCode:
                state.localRep.localRepData.postalCode ||
                (state.widget.endUserLocation || {}).postalCode ||
                state.cachedFormData.postalCode ||
                '',
            stateId:
                state.localRep.localRepData.state ||
                (state.widget.endUserLocation || {}).region ||
                state.cachedFormData.stateId ||
                '',
            homeCity:
                state.localRep.localRepData.address.city ||
                state.cachedFormData.homeCity ||
                '',
            homeAddress: state.cachedFormData.homeAddress || '',
            unit: state.cachedFormData.unit || '',
            phone: state.cachedFormData.phone || '',
            smsUpdates: true,
            confirmationEmail: true,
            getUpdates: true
        }
    })),
    reduxForm({
        form: 'voteRegistrationStep2Form',
        validate: validateStep2,
        destroyOnUnmount: false,
        enableReinitialize: true
    })
)(VoteRegistrationStep2Form);



// WEBPACK FOOTER //
// ./src/components/VoteRegistration/VoteRegistrationStep2Form.jsx